// extracted by mini-css-extract-plugin
export var gif = "_kt-0";